import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import {
  CenterGroup,
  Icon,
  LeftGroup,
  LinkButton,
  RightGroup,
  TextAutocompleteField,
  TextField,
  ToggleButtons,
  Toolbar,
} from '../../../../components';
import Sellables from '../../store/sellable/Sellables';

export default observer(function SellableListToolbar({
  actions,
  createRoute,
  sellables,
  sellableName,
  tags = false,
}: {
  actions?: ReactNode;
  createRoute: string;
  sellableName: string;
  sellables?: Sellables<any>;
  tags?: boolean;
}) {
  return (
    <Toolbar sx={{ mb: 3 }}>
      <LeftGroup>
        {tags && (
          <TextAutocompleteField
            disabled={!sellables || sellables.isEmpty}
            onChange={(e) => sellables?.setNameFilter(e.target.value)}
            options={sellables?.getTagOptions?.() || []}
            placeholder="Search by name or tag…"
            size="small"
            startAdornment={<Icon icon="search" sx={{ mr: 0 }} />}
            sx={{ mt: 0, width: 240 }}
            value={sellables?.nameFilter || ''}
          />
        )}
        {!tags && (
          <TextField
            disabled={!sellables || sellables.isEmpty}
            onChange={(e) => sellables?.setNameFilter(e.target.value)}
            placeholder="Search by name…"
            size="small"
            startAdornment={<Icon icon="search" sx={{ mr: 0 }} />}
            sx={{ mt: 0, width: 176 }}
            value={sellables?.nameFilter || ''}
          />
        )}
      </LeftGroup>

      <CenterGroup>
        <ToggleButtons
          onChange={sellables?.setStateFilter}
          options={[
            { label: 'Published', value: 'published' },
            { label: 'Archived', value: 'archived', icon: 'archive' },
          ]}
          value={sellables?.stateFilter}
        />
      </CenterGroup>

      <RightGroup>
        <LinkButton icon="plus" size="small" to={createRoute} type="primary">
          Create {sellableName}
        </LinkButton>
        {actions}
      </RightGroup>
    </Toolbar>
  );
});
